import { blogPosts } from "./blogPosts";
import { blogOgImageMap } from "./blogOgImageMap";
// Relative, not `@/lib/seoMetadata`. `importTsModule` in
// `scripts/generate-static-meta.mjs` rewrites relative specifiers only, so the
// alias kept this module unloadable from the build and forced the generator to
// re-implement the resolution below. SYSTEM_DESIGN.md 13b.3, CWS-67.
import { getLocalizedOgImagePath, normalizeSeoLanguage } from "../lib/seoMetadata";

/**
 * Resolves the OG image path for a given route path (without language prefix).
 * Returns null to indicate "use default homepage OG image".
 *
 * Blog posts resolve a per-locale card (CWS-118): the art carries the headline
 * burned in, so the requested language picks the card rendered in it, falling
 * back to the English card when the locale spelling is not one the site
 * ships — the same `localized[lang] || localized.en` rule
 * `getLocalizedOgImagePath` applies to route art.
 */
export function getOgImageForRoute(routePath: string, lang = "en"): string | null {
  const localized = getLocalizedOgImagePath(routePath, lang);
  if (localized) {
    return localized;
  }

  if (routePath.startsWith("blog/")) {
    const slug = routePath.replace("blog/", "");
    const post = blogPosts.find((p) => p.slug === slug);
    const byLocale = post ? blogOgImageMap[post.heroImage] : undefined;
    if (byLocale) {
      return byLocale[normalizeSeoLanguage(lang)] || byLocale.en;
    }
  }

  return null;
}
